export * from "ce/pages/AppViewer/BackToHomeButton";
import { default as CE_BackToHomeButton } from "ce/pages/AppViewer/BackToHomeButton";
export default CE_BackToHomeButton;
